import React from "react";

import classes from "./styles.module.scss";

const Textarea = ({ label, placeholder, minHeight, resize = "both", withLimit = false, limit = 0, value = "", ...textareaProps }) => (
    <div className={classes.textareaContainer}>
        {label && <label className={classes.label}>{label}</label>}
        <textarea
            className={classes.textarea}
            style={{ minHeight, resize }}
            placeholder={placeholder}
            value={value}
            {...textareaProps}
        />
        {withLimit && (
            <div className={classes.limit}>
                {value.length}/{limit}
            </div>
        )}
    </div>
);

export default Textarea;
